import * as shared from "@/styles/shared";
import { MeterSubmissionKind } from "@shared/types/meter";
import { useTranslation } from "react-i18next";
import * as styles from "../MeterReadingsPage.styles";
import type { SettingsCardProps } from "./types";

const SettingsCard = ({ form, actions }: SettingsCardProps) => {
  const { t } = useTranslation(["common", "meterReadings"]);

  return (
    <div className={styles.card}>
      <h2 className={styles.cardTitle}>{t("meterReadings:settings.title")}</h2>
      <p className={styles.cardDescription}>{t("meterReadings:settings.linkHint")}</p>
      <div className={styles.fieldGroup}>
        <label className={shared.titleSm}>{t("meterReadings:settings.reportName")}</label>
        <input value={form.reportName} onChange={(e) => actions.changeName(e.target.value)} className={styles.input} />
      </div>
      <div className={styles.fieldGroup}>
        <label className={shared.titleSm}>{t("meterReadings:settings.reportAddress")}</label>
        <input value={form.reportAddress} onChange={(e) => actions.changeAddress(e.target.value)} className={styles.input} />
      </div>
      <div className={styles.fieldGroup}>
        <label className={shared.titleSm}>{t("meterReadings:settings.reportCustomerCode")}</label>
        <input value={form.reportCustomerCode} onChange={(e) => actions.changeCustomerCode(e.target.value)} className={styles.input} />
      </div>
      <div className={styles.fieldGroup}>
        <label className={shared.titleSm}>{t("meterReadings:settings.reportPhone")}</label>
        <input value={form.reportPhone} onChange={(e) => actions.changePhone(e.target.value)} className={styles.input} />
      </div>
      {form.settings?.provider.submission === MeterSubmissionKind.EMAIL && (
        <>
          <div className={styles.fieldGroup}>
            <label className={shared.titleSm}>{t("meterReadings:settings.reportEmail")}</label>
            <input type="email" value={form.reportEmail} onChange={(e) => actions.changeEmail(e.target.value)} className={styles.input} />
          </div>
          <div className={styles.fieldGroup}>
            <label className={shared.titleSm}>{t("meterReadings:settings.reportCc")}</label>
            <input type="email" value={form.reportCc} onChange={(e) => actions.changeCc(e.target.value)} className={styles.input} />
          </div>
        </>
      )}
      <div className={styles.formActions}>
        <button onClick={() => void actions.save()} disabled={form.savingSettings || !form.settings?.address} className={styles.saveButton}>
          {form.savingSettings ? t("meterReadings:processing") : t("meterReadings:settings.save")}
        </button>
      </div>
      {form.error && <p className={shared.errorText}>{form.error}</p>}
    </div>
  );
};

export default SettingsCard;
